var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.active)?_c('substrate',{staticClass:"what-is-this-modal",on:{"close":function($event){_vm.active = false}}},[_c('img',{staticClass:"substrate__popup-change-pass__image",attrs:{"src":_vm.imgSrc,"alt":"card"}}),(_vm.subText)?_c('p',{staticClass:"m-t-40"},[_vm._v(_vm._s(_vm.subText))]):_vm._e()]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }